import { render, staticRenderFns } from "./BusinessCustomerDetailsInputV2.vue?vue&type=template&id=f8a39270&scoped=true&"
import script from "./BusinessCustomerDetailsInputV2.vue?vue&type=script&lang=js&"
export * from "./BusinessCustomerDetailsInputV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a39270",
  null
  
)

export default component.exports